import { CellClickedEvent, ColDef } from '@ag-grid-community/core';
import AgGridSolid, { AgGridSolidRef } from '@ag-grid-community/solid';
import logo from '@assets/logo.svg';
import { Box } from '@atgfr8/atg-ui-tailwind';
import { BasicModal, Button, Notification } from '@components';
import { getRowGroupStyle } from '@components/Grid/utils';
import { useNavigate } from '@solidjs/router';
import { closeModal, openModal, warningDataStore } from '@store/index';
import { dateFormatter, OldLoad } from '@store/loadboard';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { routeOrderDetails } from '@utils/routeOrderDetails';
import { createSignal, Setter } from 'solid-js';
import '../../Grid/AgGridStyles.css';

import AddressLoadModal from './AddressLoadModal';

const agGridCellStyle = {
  padding: '5px 5px',
  'word-break': 'break-word',
  'white-space': 'normal',
  'line-height': '1',
  'align-items': 'center !important',
};

const commonColumns: ColDef[] = [
  {
    field: 'orderId',
    headerName: 'Order',
    minWidth: 90,
    maxWidth: 110,
    filter: false,
    cellStyle: agGridCellStyle,
  },
  {
    field: 'customerName',
    headerName: 'Customer',
    filter: 'agTextColumnFilter',
    minWidth: 130,
    maxWidth: 250,
    autoHeight: true,
    cellStyle: agGridCellStyle,
  },
  {
    field: 'customerName',
    headerName: 'Carrier',
    filter: 'agTextColumnFilter',
    minWidth: 130,
    maxWidth: 250,
    autoHeight: true,
    cellStyle: agGridCellStyle,
  },
  {
    field: 'origin',
    headerName: 'Origin',
    filter: 'agTextColumnFilter',
    minWidth: 130,
    maxWidth: 250,
    autoHeight: true,
    cellStyle: agGridCellStyle,
    cellRenderer: (params: { data: OldLoad }) => {
      return (
        <span>
          {params.data.originCity}, {params.data.originState}
        </span>
      );
    },
  },
  {
    field: 'dropDate',
    headerName: 'Drop Date',
    filter: 'agDateColumnFilter',
    filterParams: {
      minValidYear: 1900,
      maxValidYear: new Date().getFullYear() + 1,
    },
    maxWidth: 110,
    minWidth: 110,
    valueFormatter: dateFormatter,
  },
  {
    field: 'destination',
    headerName: 'Destination',
    filter: 'agTextColumnFilter',
    minWidth: 130,
    maxWidth: 250,
    autoHeight: true,
    cellStyle: agGridCellStyle,
    cellRenderer: (params: { data: OldLoad }) => {
      return (
        <span>
          {params.data.destinationCity}, {params.data.destinationState}
        </span>
      );
    },
  },
  {
    field: 'agent',
    headerName: 'Owner',
    filter: 'agTextColumnFilter',
    minWidth: 90,
    maxWidth: 150,
    autoHeight: true,
    cellStyle: agGridCellStyle,
  },
  {
    field: 'loadStatus',
    headerName: 'Status',
    filter: 'agTextColumnFilter',
    minWidth: 90,
    maxWidth: 150,
    autoHeight: true,
    cellStyle: agGridCellStyle,
  },
  {
    field: 'Action',
    headerName: 'Action',
    colId: 'Action',
    filter: 'agTextColumnFilter',
    minWidth: 90,
    autoHeight: true,
    cellStyle: agGridCellStyle,
    cellRenderer: (params: { data: OldLoad }) => {
      return (
        <Button
          label="Address Load"
          color="primary"
          size="sm"
          sx={{ 'margin-left': '10px' }}
          onClick={() => {
            setSelectedLoad(params.data);
            openModal(AddressLoadModalId);
          }}
          dataTestId={formatDataTestId('Address Load', 'button')}
        />
      );
    },
  },
];

export const AddressLoadModalId = 'address_load_modal';
const [selectedLoad, setSelectedLoad] = createSignal<OldLoad | undefined>();
const OldLoadWaringGrid = (props: { setActiveTab: Setter<number> }) => {
  const navigate = useNavigate();
  let gridRef: AgGridSolidRef | undefined;
  const imageTag = `<img src=${logo} alt="" />`;

  return (
    <>
      <Notification
        sxProps="bg-white! text-sm!"
        type="error"
        text={
          <span class="text-sm">
            Please go through this list of loads over 2 months old and void them
            if they did not happen, or allow us to seek the paperwork or invoice
            the customer if they did happen.
          </span>
        }
      />
      <Box class="ag-theme-alpine flex flex-col flex-1! h-[83%]! ">
        <AgGridSolid
          ref={gridRef}
          columnDefs={commonColumns}
          rowData={warningDataStore.oldLoad.data.data}
          gridOptions={{
            defaultColDef: {
              flex: 1,
              filter: false,
            },
          }}
          getRowStyle={getRowGroupStyle}
          overlayLoadingTemplate={imageTag}
          noRowsOverlayComponent={imageTag}
          onCellClicked={(e: CellClickedEvent) => {
            if (e.colDef.colId !== 'Action') {
              const orderId = (e.data as { orderId: number }).orderId;
              if (routeOrderDetails(orderId)) {
                props.setActiveTab(-1);
                navigate(`/order/details/${orderId}`);
              }
            }
          }}
        />
      </Box>
      <BasicModal
        id={AddressLoadModalId}
        footer={false}
        showClose
        width="700px"
        maxWidth="700px"
        height="503px"
        onClose={() => {
          closeModal(AddressLoadModalId);
          selectedLoad();
        }}
        title={`Old Load #${selectedLoad() ? selectedLoad()?.orderId : ''}`}
      >
        <AddressLoadModal selectedLoad={selectedLoad()} />
      </BasicModal>
    </>
  );
};

export default OldLoadWaringGrid;
